$(document).ready(function(){
	$('.slider').slick({
		arrows: false,
		dots: false,
		infinite: true,
		speed: 500,
		autoplay: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		adaptiveHeight: true
	});

	$('.slider-nav > li').click(function() {
		$('.slider-nav > li').removeClass('active');
		$(this).addClass('active');
		$('.slider').slick('slickGoTo',$(this).index());
	});
});

$('.hamburger').click(function(e){
	e.preventDefault();
	var navigation = $("nav");

	if ($(this).hasClass('active')) {
		$(this).removeClass('active');
		navigation.removeClass('active').slideUp(100);
	}
	else {
		$(this).addClass('active');
		navigation.addClass('active').slideDown(150);
	}
});


$(".order-row .expand").click(function(){
	if ($(this).hasClass("active")) {
		$(this).find("i").attr('class', 'fas fa-plus-square');
		$(this).removeClass("active").parent().next(".product-list").slideUp(200);
	}
	else {
		$(this).find("i").attr('class', 'fas fa-minus-square');
		$(this).addClass("active").parent().next(".product-list").slideDown(250);
	}
});


var collection = document.getElementsByClassName("collection-page");
if (collection) {
	var modal = document.getElementById("modal");

	$(".filters").clone().appendTo(".modal-content");
	$(".utilities .filter").click(function(){
		$("body").addClass("modal");
		$(modal).addClass("active");
	});

	$(".modal-content .close").click(function(){
		$(modal).removeClass("active");
		$("body").removeClass("modal");
	});
}

const $sorter = $('.sort-by');
let sortBy = false;

if (window.location.search.length) {
	sortBy = new URLSearchParams(window.location.search).get('sort_by')
}
//preserve current selection
// set sort value to present query
if(sortBy) {
	$sorter.val(sortBy);
}

$sorter.on('change', (e) => {
	const { value } = e.currentTarget;
	window.location = `?sort_by=${value}`
});

$("input[name='updates[]']").on('change', function() {
	$( "button[name='update']" ).trigger( "click" );
});


var addressList = $(".address-list");
var addressForm = $(".account-address-form");
var addressButtonFocus = null;

addressList.on('click', '[data-edit-address]', function (event) {
	var target = $(event.currentTarget);
	var itemId = target.attr('data-edit-address');

	addressForm.removeClass('visible');
	$(this).addressButtonFocus = target;

	$('[data-address-id="' + itemId + '"]').addClass('visible').find('.form-field-input').eq(0).focus();
});

addressForm.on('click', '[data-edit-address-cancel]', function () {
	addressForm.removeClass('visible');
	$('[data-address-id="new"]').addClass('visible');
	$addressButtonFocus.focus();
	addressButtonFocus = null;
});


var accountLogin = $('.login-panel');
var loginToggle = accountLogin.find('[data-login-toggle]');
var loginPanel = accountLogin.find('[data-account-login-main]');
var loginRecovery = accountLogin.find('[data-account-login-recovery]');
var recoveryMessage = accountLogin.find('[data-recovery-has-message]');

loginToggle.on('click', function() {
	toggleLogin();
});
if (recoveryMessage.length) {
	toggleLogin();
}

function toggleLogin() {
	var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

	if (event) {
		event.preventDefault();
	}

	loginPanel.toggleClass('visible');
	loginRecovery.toggleClass('visible');
}